export const CHEMICAL_DB_API_HOST = import.meta.env.VITE_CHEMICAL_DB_API_BASE_URL;

export const CHEMICALS_API = '/api/chemicals';

export const CHEMICALS_ENRICH_API = '/api/chemicals/enrich';

export const JSON_HEADERS = { 'Content-Type': 'application/json' };
